import { FlexGrid, CellType,CellRange } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';


/**
 * データグリッドの挙動の実装を補助する共通部品クラス
 *
 * @export
 * @class DataGridUtil
 */
export class DataGridUtil {

  /** 昇順の記号 */
  static readonly ASC_SIGN: string = String('▲');

  /** 降順の記号 */
  static readonly DESC_SIGN: string = String('▼');

  /** 昇順をあらわす文字列 */
  static readonly ASC_STRING: string = String('ASC');

  /** 降順をあらわす文字列 */
  static readonly DESC_STRING: string = String('DESC');


  /**
   * ヘッダーテキスト初期化
   * 引数で渡されたデータグリッドの列テキストをすべて初期化する
   * ※データグリッドの列内にデフォルトで「▲」や「▼」があれば
   * 　挙動がおかしくなります(なければ気にしなくてかまいません)
   *
   * @static
   * @param {FlexGrid} dataGrid 対象データグリッド
   * @memberof DataGridUtil
   */
  static clearHeaderText(dataGrid: FlexGrid): void {
    // 引数で渡されたDataGridの列分処理する
    for (let i = Number(0); i < dataGrid.columns.length; i++) {
      // ヘッダテキストの取得
      const headerColumnTextValue = dataGrid.columns[i].header;

      // ヘッダテキストの末尾の1文字が昇順記号・降順記号でないか判定
      if (headerColumnTextValue.substr(-1, 1) === this.ASC_SIGN
      ||  headerColumnTextValue.substr(-1, 1) === this.DESC_SIGN) {
        // 記号であれば、末尾1文字削って、ヘッダテキストを更新する
        dataGrid.columns[i].header = headerColumnTextValue.substring(0, headerColumnTextValue.length - 1);
      }
    }
  }

  /**
   * ソート可否判定
   * 引数で渡されたイベントオブジェクト、データグリッドでソート可否の判定結果を返却する。
   *
   * @static
   * @param {MouseEvent} e DataGrid上で発生したイベントオブジェクト(HeaderReleaseイベントをフックして引数としてください)
   * @param {FlexGrid} grid 対象データグリッド
   * @returns {boolean} 判定結果(true：ソート可能、false：ソート不可)
   * @memberof DataGridUtil
   */
  static isSortable(e: MouseEvent, grid: FlexGrid): boolean {
    // データ件数のチェック
    // 項番2231 START 障害管理NO.I00372対応
    // if (grid.itemsSource === null || grid.itemsSource.length < 1) {             // データなしの場合
    if (grid.itemsSource == null || grid.itemsSource.length < 1) {             // データなしの場合
    // 項番2231 END 障害管理NO.I00372対応
      // 判定結果を返却
      return false;
    }

    // ヘッダー内部のがクリックされていない場合は何もしない
    if (grid.hitTest(e).cellType !== CellType.ColumnHeader              // カラムヘッダーではない、
    ||  grid.hitTest(e).edgeLeft                                                // 左端、
    ||  grid.hitTest(e).edgeRight) {                                            // 右端の場合
      // 判定結果を返却
      return false;
    }

    // 判定結果を返却
    return true;
  }

  /**
   * ヘッダーテキスト切替
   * 引数のイベントオブジェクトを元に、データグリッドのヘッダ行の昇順・降順のテキストを切り替えます
   * この際、該当行に昇順・降順のテキストが存在していない場合は、データグリッドのヘッダテキストの初期化を行い、
   * クリックされた箇所の昇順・降順テキストを切り替えます
   *
   * @static
   * @param {MouseEvent} e DataGrid上で発生したイベントオブジェクト(HeaderReleaseイベントをフックして引数としてください)
   * @param {FlexGrid} grid 対象データグリッド
   * @returns {string} 対象の列が昇順であるか、降順であるかを文字列で返す(ASC：昇順、DESC：降順)
   * @memberof DataGridUtil
   */
  static switchHeaderText(e: MouseEvent, grid: FlexGrid): string {
    // クリック取得
    const htInfo: any = grid.hitTest(e);

    // 戻り値の定義
    let retTxt: string = this.ASC_STRING;

    // ヘッダテキストの取得
    const headerTextValue: string = grid.columns[htInfo.col].header;
    // ヘッダテキストの末尾の一文字が昇順記号ではないか
    if (headerTextValue.slice(-1) === this.ASC_SIGN) {
      // 昇順なので降順にスイッチする
      grid.columns[htInfo.col].header = headerTextValue.slice(0, -1) + this.DESC_SIGN;

      // 戻り値をDESCに
      retTxt = this.DESC_STRING;
    } else if (headerTextValue.slice(-1) === this.DESC_SIGN) {
      // 降順なので昇順にスイッチする
      grid.columns[htInfo.col].header = String(headerTextValue).slice(0, -1) + this.ASC_SIGN;
    } else {
      // データグリッドのヘッダ行初期化
      this.clearHeaderText(grid);

      // 昇順記号を付与
      grid.columns[htInfo.col].header = headerTextValue.concat(this.ASC_SIGN);
    }

    return retTxt;
  }

    /**
   * グリッド内にコンテキストメニューを表示
   * クリック時のセルを選択
   * @param g
   * @param m
   * @param e
   * @returns
   * @memberof DataGridUtil
   */
    static showContextMenu(g: FlexGrid, m: Menu, e: MouseEvent) {
      const ht = g.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell) {
        // 右クリック押下時に対象行を選択状態にする
        const cr = new CellRange(ht.row, ht.col);
        g.select(cr, false);
        m.show(e);
      }
    }

}
